import React from "react"
import { useTranslation } from "react-i18next"
import FacebookIcon from "../../../resource/icon/facebook.svg"
import ShareButton from "./ShareButton"

interface FacebookButtonProps {
  order: number
  shareUrl: string
  prefillTweetText?: string
  hashtags: string
  facebookAppId: string
  trackClick: () => void
}

export default function FacebookButton({ order, facebookAppId, hashtags, shareUrl, trackClick }: FacebookButtonProps) {
  const DEFAULT_FACEBOOK_APP_ID = 314518542022141 /* 865435973597059 */

  const { t } = useTranslation()

  const shareToFacebook = () => {
    trackClick()

    let appId = encodeURIComponent(facebookAppId ?? DEFAULT_FACEBOOK_APP_ID)
    let url = encodeURIComponent(shareUrl)
    let encodedHashtags = encodeURIComponent(hashtags)

    window.open(`https://www.facebook.com/dialog/share?app_id=${appId}&href=${url}&hashtag=${encodedHashtags}&mobile_iframe=true`)
  }

  return (
    <ShareButton
      order={order}
      onClick={shareToFacebook}
      style={{ backgroundColor: "#326299" }}
    >
      <img src={FacebookIcon} />
      {t("shareSheet.buttons.facebook")}
    </ShareButton>
  )
}